import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ImagilityBaseResponse } from 'app-models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs/operators';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import { MoveToStepService } from './move-to-step.service';
import { VisaDesignerService } from '../visa-designer.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DEFAULT_STEPS } from '../data/constants';

@Component({
  selector: 'app-move-to-step',
  templateUrl: './move-to-step.component.html',
  styleUrls: ['./move-to-step.component.scss']
})
export class MoveToStepComponent implements OnInit {
  moveToStepForm: FormGroup;
  visaId: number;
  existingStepList: {
    stepName: string;
    index: number;
  }[] = [];
  htmlRenderObj: any = [];
  observableSubscription$ = new Subject();

  currentStepName: string = '';
  selectedStep = null;
  selectedStepIndex = 0;
  isCreate: boolean = false;
  isCreateButton: Boolean = false;
  isEdit: boolean = false;
  customStepId: any;
  excludedSteps = [];



  constructor(
    private toastr: ToastrService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private store: Store<any>,
    private moveToStepService: MoveToStepService,
    private VDService: VisaDesignerService,
    private cRef: ChangeDetectorRef
  ) {
    this.VDService.buildStepsSelectedData = this.config.data.buildStepsSelectedData;
    this.moveToStepForm = new FormGroup({
      stepType: new FormControl('new'),
      newStepName: new FormControl(null),
      existingStepName: new FormControl(null)
    }, [this.newStepNameRequired, this.existingStepNameRequired]);
  }

  newStepNameRequired(group: FormGroup): { [s: string]: boolean } {
    if (group && group.value.stepType && group.value.stepType === 'new' &&
      (!group.value.newStepName || (group.value.newStepName && group.value.newStepName.trim() === ''))) {
      return { newStepNameIsRequired: true };
    }
    return null;
  }

  existingStepNameRequired(group: FormGroup): { [s: string]: boolean } {
    if (group && group.value.stepType && group.value.stepType === 'existing' &&
      group.value.existingStepName === null) {
      return { existingStepNameIsRequired: true };
    }
    return null;
  }

  ngOnInit() {
    // work around for primeng radio button
    this.moveToStepForm.get('stepType').valueChanges.subscribe(e => {
      this.moveToStepForm.get('stepType').setValue(e, { emitEvent: false });
    });

    this.store.select(fromVDTask.getVDVisaId)
      .pipe(take(1))
      .subscribe((visaId: number) => {
        this.visaId = visaId;
        this.getExistingSteps();
      });
  }

  getExistingSteps() {
    if (this.visaId) {
      this.moveToStepService.getExistingSteps(this.visaId)
        .pipe(take(1))
        .subscribe((response: ImagilityBaseResponse) => {
          if (response) {
            if (response.status === 200) {
              this.existingStepList = [{
                stepName: 'Select',
                index: null
              }];
              (JSON.parse(response.data.stepJson) as any[]).forEach((x, i) => {
                if (!x.id) {
                  this.existingStepList.push({
                    stepName: x.stepName,
                    index: i
                  });
                }
              });
            } else if (response.status === 404) {
              this.existingStepList = [];
            }
          }
        });
    }
  }

  onSubmit() {
    if (this.moveToStepForm.value.stepType == 'new') {
      this.VDService.visaType = 'new';
      this.VDService.currentStepName = this.moveToStepForm.value.newStepName;
      this.getSavedSteps(this.visaId);
    }
    else if (this.moveToStepForm.value.stepType == 'existing') {
      this.VDService.visaType = 'existing';
      this.VDService.currentStepName = this.moveToStepForm.value.existingStepName
      this.getSavedSteps(this.visaId);
    }
    else {
      this.VDService.visaType = '';
      this.VDService.currentStepName = '';
      this.VDService.buildStepsSelectedData = [];
      this.ref.close({ moved: true });
    }
  }

  close() {
    this.ref.close();
  }



  createNewStep() {
    this.currentStepName = this.VDService.currentStepName;
    this.selectedStep = { stepName: this.currentStepName, id: null, stepTypeId: 182, controlArray: [] };

    this.calcRowsColumns();
    this.selectedStep.controlArray.push(...this.VDService.buildStepsSelectedData);
    // for (var i = 0; i < this.VDService.buildStepsSelectedData.length; i++) {
    //   this.selectedStep.controlArray.push(this.VDService.buildStepsSelectedData[i]);
    // }

    this.selectedStep.actionNotifyFlag = [{
      isPetnrAtrnyActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }, {
      isBeneficiaryActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }];
    this.htmlRenderObj.push(this.selectedStep);
    this.isCreate = false;
    this.isCreateButton = false;
    this.isEdit = true;
    this.selectedStepIndex = (this.htmlRenderObj.length - 1);
    this.customStepId = this.selectedStepIndex;
    localStorage.setItem('customStepId', this.customStepId);
    this.saveSteps();

  }

  saveSteps() {
    if (this.htmlRenderObj.length > 0) {
      let i = 1;
      this.htmlRenderObj.forEach(item => {
        item.sequenceNo = i * 10;
        i++;
      });
    }

    const payload = {
      stepJson: JSON.stringify(this.htmlRenderObj),
      visaId: this.visaId
    }
    this.VDService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if (response && response.status === 200) {
        this.htmlRenderObj = [];
        this.VDService.buildStepsSelectedData = [];
        this.toastr.success('Step is successfully saved', 'Success');
        localStorage.setItem('selectedStep', null);
        this.ref.close({ moved: true });
      }
    });
  }

  getSavedSteps(visaId) {
    let vId = Number(visaId);
    this.VDService.getVisaById(vId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.htmlRenderObj = (response?.data?.stepJson && JSON.parse(response.data.stepJson).length > 0) ? JSON.parse(response.data.stepJson) : DEFAULT_STEPS;
      if (this.VDService.visaType == 'new') {
        this.createNewStep();
      }
      else if (this.VDService.visaType == 'existing') {
        const allRows = this.htmlRenderObj[this.VDService.currentStepName].controlArray.filter(row => row.numberOfRow).map(row => Number(row.numberOfRow));
        let maxRow: number = 0;
        if (allRows && allRows.length > 0) {
          maxRow = Math.max(...allRows);
        }
        this.calcRowsColumns(maxRow);
        this.htmlRenderObj[this.VDService.currentStepName].controlArray.push(...this.VDService.buildStepsSelectedData);
        // for (var i = 0; i < this.VDService.buildStepsSelectedData.length; i++) {
        //   this.htmlRenderObj[this.VDService.currentStepName].controlArray.push(this.VDService.buildStepsSelectedData[i]);
        // }
        this.saveSteps();
      }

      this.excludedSteps = [];
    });
  }

  calcRowsColumns(maxRow: number = 0) {
    const rows = Array.from(new Set(this.VDService.buildStepsSelectedData
      .map(x => x.numberOfRow)))
      .sort((a, b) => a - b);
    let buildStepsSelectedData = [];
    rows.forEach((row) => {
      const cols = this.VDService.buildStepsSelectedData.filter(x => x.numberOfRow === row);
      // const totalCols = cols.reduce((a, b) => a + (b.numberOfColumn || 0), 0);
      // const remainderCols = totalCols < 12 && totalCols > 0 ?
      //   (12 - totalCols) : (totalCols % 12);
      // if (remainderCols > 0 || (totalCols % 12 === 0)) {
      //   cols.push({
      //     emptyCol: true
      //   });
      // }
      buildStepsSelectedData.push(...cols);
    })
    buildStepsSelectedData = buildStepsSelectedData.map(x => {
      if (x.numberOfRow) {
        return {
          ...x,
          numberOfRow: x.numberOfRow + maxRow
        }
      } else {
        return {
          ...x
        }
      }
    })
    this.VDService.buildStepsSelectedData = [...buildStepsSelectedData];
  }


}

